import * as core from '../../../../../../../core'

import { query } from './org-employee-tree.query'

export const RESOURCE = {
  payload: {
    alias: 'org-employee-tree',
    description:
      "Chart used to display and explore the organization's employee structure",
    name: 'Employee Organization Tree',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
